import { formatData } from "@shared/lib/utils/formatData";
import { Typography } from "@shared/ui";
import styles from "../ui/YoutubeSearchResultsTable.module.scss";

const { Text } = Typography;

export function formatEngagement(rate: number): string {
  const percent = rate;
  return `${percent.toFixed(2)}%`;
}

export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds)) {
    return "—";
  }
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);
  if (hours > 0) {
    return `${hours}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }
  return `${minutes}:${String(secs).padStart(2, "0")}`;
}

export function Stat({ value }: { value: number }) {
  return <Text className={styles.statValue}>{formatData(value)}</Text>;
}

export function Clip({ value }: { value?: string }) {
  return (
    <Text ellipsis={{ tooltip: value }} className={styles.clipText}>
      {value || "—"}
    </Text>
  );
}
